import { useShadowRootElements } from '@backstage/plugin-techdocs-react';
import { Portal } from '@material-ui/core';
import { PageDescription } from './PageDescription';

const CONTENT_HEADER_CONTAINER_ID = 'af-techdocs-content-header-container';

export const ContentHeaderAddon = () => {
  const [content] = useShadowRootElements(['article.md-content__inner']);
  const [heading] = useShadowRootElements(['article.md-content__inner h1']);
  let container: HTMLDivElement | null = content?.querySelector(
    `#${CONTENT_HEADER_CONTAINER_ID}`,
  );
  if (!container) {
    container = document.createElement('div');
    container.setAttribute('id', CONTENT_HEADER_CONTAINER_ID);
    if (heading) {
      heading.after(container);
    } else if (content) {
      content.prepend(container);
    }
  }
  return (
    <Portal container={container}>
      <PageDescription />
    </Portal>
  );
};
